import type { BookingTransactionDataInput } from '@drycut/graphql';

import { BookingCheckoutButton, PreBookingCheckoutButton } from '@drycut/controlled-components';
import { Para, Stack } from '@drycut/ui-components';
import { useWatch } from 'react-hook-form';

import { computeBookingPrice } from '../../../computeBookingPrice';
import { NewCouponInsert } from '../../../CouponInsert';
import { useCheckoutStore } from '../../checkoutStore';

export function PaymentStep(): React.ReactElement {
  const selectedStore = useCheckoutStore((state) => state.selectedStore);
  const manual = useCheckoutStore((state) => state.manual);
  const scheduled = useCheckoutStore((state) => state.scheduled);
  const selectedSchedule = useCheckoutStore((state) => state.selectedSchedule);
  const selectedServices = useCheckoutStore((state) => state.selectedServices);
  const selectedCoupon = useCheckoutStore((state) => state.selectedCoupon);
  const setSelectedCoupon = useCheckoutStore((state) => state.setSelectedCoupon);

  const customerName = useWatch({ name: 'name' });
  const phoneNumber = useWatch({ name: 'phone' });
  const silentBooking = useWatch({ name: 'silentBooking' });

  const computedPrice = computeBookingPrice({
    tax: selectedSchedule ? selectedStore?.preBookingTax || 0 : 0,
    services: selectedServices,
    coupon: selectedCoupon,
  });

  const bookingData: BookingTransactionDataInput = {
    manual,
    customerName,
    phoneNumber,
    silentBooking,
    serviceIds: selectedServices.map((service) => service.id),
    couponCode: selectedCoupon?.code,
    storeSlug: selectedStore?.slug || '',
  };

  return (
    <Stack gap={2}>
      <div className="flex items-center justify-center w-full grow">
        <Stack direction="row" gap={2} className="align-start pb-3 w-full">
          <Para size="xl" as="span">
            Preis:
          </Para>
          <Para size="xl" as="span" weight="medium">
            {computedPrice} CHF
          </Para>
        </Stack>
      </div>

      <NewCouponInsert onValidate={(coupon) => setSelectedCoupon(coupon)} />

      {scheduled ? (
        <PreBookingCheckoutButton
          amount={computedPrice}
          data={{ ...bookingData, bookTime: selectedSchedule?.toISO() as string }}
        />
      ) : (
        <BookingCheckoutButton amount={computedPrice} data={bookingData} />
      )}
    </Stack>
  );
}
